import React, { useEffect, useState, Fragment } from "react";
import LinksComponent from "../../../components/Tenant/LinksComponent/LinksComponent";
import { toast } from "react-hot-toast";
import {
    useBanQrMutation,
    useFetchBanQrByIdMutation,
    useFetchAllQrCodeWithoutGenerationCountMutation,
    useFetchAllQrCodeWithoutGenerationMutation,
    useFetchQrAddressMutation,
} from "../../../features/tenant/qrCode/qrCodeApi";
import { useGetAppUserTypeQuery } from "../../../features/tenant/appUserType/appUserTypeApi";
import ModalComponent from "../../../components/Tenant/ModalComponent/ModalComponent";
import DataTableComponent from "../../../components/Tenant/DataTableComponent/DataTableComponent";
import { useLocation, useNavigate } from "react-router-dom";
import ViewQr from "../../../components/Tenant/ViewQR/ViewQr";
import { getVendorName } from "../../../utils/getVendorName";
// import ExportCSV from "../../../components/ExportCsv/ExportCsv";
import { CircleLoaderComponent } from "../../../components/Loader/CircleLoaderComponent";
import ExcelJS from "exceljs";
import { saveAs } from "file-saver";
import { Menu, Transition } from "@headlessui/react";
import { AiOutlineCloudDownload } from "react-icons/ai";

function objectsAreEqual(obj1, obj2) {
    const keys1 = Object.keys(obj1);
    const keys2 = Object.keys(obj2);

    if (keys1.length !== keys2.length) {
        return false;
    }

    for (let key of keys1) {
        if (!obj2.hasOwnProperty(key)) {
            return false;
        }
        if (obj1[key] !== obj2[key]) {
            return false;
        }
    }
    return true;
}

const AllQrCodeList = () => {
    const navigate = useNavigate();
    const currentDate = new Date().toISOString().split("T")[0];
    const initialRequest = {
        product_code: "",
        product_name: "",
        batch_running_code: "",
        limit: 10,
        offset: 0,
        startDate: "",
        endDate: "",
        qr_barcode: "",
        scratch_code: "",
        address_id: ""
    };
    const initialRequestCount = {
        product_code: "",
        product_name: "",
        batch_running_code: "",

        startDate: "",
        endDate: "",
        scratch_code: "",
        address_id: ""
    };
    const [request, setRequest] = useState(initialRequest);
    const [myList, setMyList] = useState([]);
    const [totalRows, setTotalRows] = useState(0);
    const [requestCount, setRequestCount] = useState(initialRequestCount);
    const [downloadFormat, setDownloadFormat] = useState("csv");
    const clearFilters = () => {
        setRequest(initialRequest);
    };

    const location = useLocation();
    const isLancerFootwear = location.pathname.includes("lancer-footwear");

    const [addresses, setAddresses] = useState([]);
    const [
        fetchQrAddress,
        { data: addressData }
    ] = useFetchQrAddressMutation();

    useEffect(() => {
        if (isLancerFootwear) {
            fetchQrAddress({
                token: sessionStorage.getItem("access_token"),
                tenant_id: JSON.parse(sessionStorage.getItem("vendorData"))
                    .tenant_id,
            });
        }
    }, [isLancerFootwear]);

    useEffect(() => {
        if (addressData && addressData.success) {
            setAddresses(addressData.body.addresses);
        }
    }, [addressData]);

    const columns = [
        {
            name: "SNo",
            cell: (row, idx) => offset + Number(idx + 1),
            sortable: true,
        },
        {
            name: "Batch Running Code",
            cell: (row) => row.batch_running_code,
            sortable: true,
            width: "130px",
        },
        {
            name: "Product Code",
            cell: (row) => row.product_code,
            sortable: true,
        },
        {
            name: "Qr Code",
            cell: (row) => row.unique_code,
            sortable: true,
            width: "130px",
        },
        {
            name: "Scratch Code",
            cell: (row) => row.scratch_code,
            sortable: true,
        },
        {
            name: "qr Type",
            cell: (row) => (row.qr_type_name ? row.qr_type_name : "standard"),
            sortable: true,
        },
        {
            name: "Type",
            cell: (row) => (
                <span
                    className={`text-sm p-1 capitalize rounded-sm font-bold bg-${row.parent_code === null
                        ? "gray"
                        : row.parent_code === "false"
                            ? "red"
                            : "blue"
                        }-400 text-white animate-pulse duration-1000`}
                >
                    {row.parent_code === null
                        ? row.qr_type_name && row.qr_type_name == "ZCRT"
                            ? "Parent"
                            : "Child"
                        : row.parent_code === "false"
                            ? "Parent"
                            : "Child"}
                </span>
            ),
            sortable: true,
            width: "130px",
        },
        {
            name: "MRP",
            cell: (row) => row.mrp,
            sortable: true,
            width: "100px",
        },
        {
            name: "Qr Status",
            cell: (row) => (
                <span
                    className={`text-sm p-1 capitalize rounded-sm  font-bold bg-${row.qr_status == "2" ? "red" : "blue"
                        }-700 text-white animate-pulse duration-0`}
                >
                    {row.qr_status == "2" ? "Scanned" : "Not Scanned"}
                </span>
            ),
            sortable: true,
            width: "150px",
        },
        {
            name: "Created At",
            cell: (row) => new Date(row.created_at).toLocaleString(),
            sortable: true,
        },
        {
            name: "Actions",
            cell: (row) => (
                <div className="flex gap-2">
                    <button
                        className="flex justify-center items-center rounded bg-red-600 px-3 pb-1.5 break-normal pt-1.5 text-xs font-medium uppercase leading-normal text-white animate-blinking-button shadow-[0_4px_9px_-4px_#3b71ca] transition duration-150 ease-in-out hover:bg-red-700 hover:shadow-[0_8px_9px_-4px_rgba(59,113,202,0.3),0_4px_18px_0_rgba(59,113,202,0.2)] focus:bg-red-700 focus:shadow-[0_8px_9px_-4px_rgba(59,113,202,0.3),0_4px_18px_0_rgba(59,113,202,0.2)] focus:outline-none focus:ring-0 active:bg-red-700 active:shadow-[0_8px_9px_-4px_rgba(59,113,202,0.3),0_4px_18px_0_rgba(59,113,202,0.2)] dark:shadow-[0_4px_9px_-4px_rgba(59,113,202,0.5)] dark:hover:shadow-[0_8px_9px_-4px_rgba(59,113,202,0.2),0_4px_18px_0_rgba(59,113,202,0.1)] dark:focus:shadow-[0_8px_9px_-4px_rgba(59,113,202,0.2),0_4px_18px_0_rgba(59,113,202,0.1)] dark:active:shadow-[0_8px_9px_-4px_rgba(59,113,202,0.2),0_4px_18px_0_rgba(59,113,202,0.1)]"
                        onClick={() =>
                            navigate(`/genefied/${getVendorName()}/tracking`, {
                                state: row,
                            })
                        }
                    >
                        Track
                    </button>
                    <button
                        className="flex justify-center items-center rounded bg-gray-800 px-3 pb-1.5 break-normal pt-1.5 text-xs font-medium uppercase leading-normal text-white shadow-md hover:bg-gray-900 transition duration-150 ease-in-out"
                        onClick={() => handleBanClick(row)}
                    >
                        Ban
                    </button>
                    <button
                        className="flex justify-center items-center rounded bg-primary px-3 pb-1.5 break-normal pt-1.5 text-xs font-medium uppercase leading-normal text-white shadow-[0_4px_9px_-4px_#3b71ca] transition duration-150 ease-in-out hover:bg-primary-600 hover:shadow-[0_8px_9px_-4px_rgba(59,113,202,0.3),0_4px_18px_0_rgba(59,113,202,0.2)] focus:bg-primary-600 focus:shadow-[0_8px_9px_-4px_rgba(59,113,202,0.3),0_4px_18px_0_rgba(59,113,202,0.2)] focus:outline-none focus:ring-0 active:bg-primary-700 active:shadow-[0_8px_9px_-4px_rgba(59,113,202,0.3),0_4px_18px_0_rgba(59,113,202,0.2)] dark:shadow-[0_4px_9px_-4px_rgba(59,113,202,0.5)] dark:hover:shadow-[0_8px_9px_-4px_rgba(59,113,202,0.2),0_4px_18px_0_rgba(59,113,202,0.1)] dark:focus:shadow-[0_8px_9px_-4px_rgba(59,113,202,0.2),0_4px_18px_0_rgba(59,113,202,0.1)] dark:active:shadow-[0_8px_9px_-4px_rgba(59,113,202,0.2),0_4px_18px_0_rgba(59,113,202,0.1)] "
                        onClick={() => handleShowQr(row)}
                    >
                        GVerify QR
                    </button>
                    <button
                        className="flex justify-center items-center rounded bg-primary px-3 pb-1.5 break-normal pt-1.5 text-xs font-medium uppercase leading-normal text-white shadow-[0_4px_9px_-4px_#3b71ca] transition duration-150 ease-in-out hover:bg-primary-600 hover:shadow-[0_8px_9px_-4px_rgba(59,113,202,0.3),0_4px_18px_0_rgba(59,113,202,0.2)] focus:bg-primary-600 focus:shadow-[0_8px_9px_-4px_rgba(59,113,202,0.3),0_4px_18px_0_rgba(59,113,202,0.2)] focus:outline-none focus:ring-0 active:bg-primary-700 active:shadow-[0_8px_9px_-4px_rgba(59,113,202,0.3),0_4px_18px_0_rgba(59,113,202,0.2)] dark:shadow-[0_4px_9px_-4px_rgba(59,113,202,0.5)] dark:hover:shadow-[0_8px_9px_-4px_rgba(59,113,202,0.2),0_4px_18px_0_rgba(59,113,202,0.1)] dark:focus:shadow-[0_8px_9px_-4px_rgba(59,113,202,0.2),0_4px_18px_0_rgba(59,113,202,0.1)] dark:active:shadow-[0_8px_9px_-4px_rgba(59,113,202,0.2),0_4px_18px_0_rgba(59,113,202,0.1)] "
                        onClick={() => handleWebGenefiedQr(row)}
                    >
                        Web Qr
                    </button>
                    <button
                        className="flex justify-center items-center rounded bg-primary px-3 pb-1.5 break-normal pt-1.5 text-xs font-medium uppercase leading-normal text-white shadow-[0_4px_9px_-4px_#3b71ca] transition duration-150 ease-in-out hover:bg-primary-600 hover:shadow-[0_8px_9px_-4px_rgba(59,113,202,0.3),0_4px_18px_0_rgba(59,113,202,0.2)] focus:bg-primary-600 focus:shadow-[0_8px_9px_-4px_rgba(59,113,202,0.3),0_4px_18px_0_rgba(59,113,202,0.2)] focus:outline-none focus:ring-0 active:bg-primary-700 active:shadow-[0_8px_9px_-4px_rgba(59,113,202,0.3),0_4px_18px_0_rgba(59,113,202,0.2)] dark:shadow-[0_4px_9px_-4px_rgba(59,113,202,0.5)] dark:hover:shadow-[0_8px_9px_-4px_rgba(59,113,202,0.2),0_4px_18px_0_rgba(59,113,202,0.1)] dark:focus:shadow-[0_8px_9px_-4px_rgba(59,113,202,0.2),0_4px_18px_0_rgba(59,113,202,0.1)] dark:active:shadow-[0_8px_9px_-4px_rgba(59,113,202,0.2),0_4px_18px_0_rgba(59,113,202,0.1)] "
                        onClick={() => handleBatchShowQr(row)}
                    >
                        View Qr
                    </button>
                </div>
            ),
            width: "500px",
        },
    ];
    const [loading, setLoading] = useState(false);
    const [limit, setLimit] = useState(10);
    const [offset, setOffset] = useState(0);
    const [currentPage, setCurrentPage] = useState(1);
    const [paginationResetToggle, setPaginationResetToggle] = useState(false);

    const [
        qrListDataFun,
        {
            data: qrListData,
            isLoading: qrListDataIsLoading,
            error: qrListDataError,
        },
    ] = useFetchAllQrCodeWithoutGenerationMutation();

    const [
        qrListDataCountFun,
        {
            data: qrListDataCount,
            isLoading: qrListDataCountIsLoading,
            error: qrListDataCountError,
        },
    ] = useFetchAllQrCodeWithoutGenerationCountMutation();

    const [banQr, { isLoading: banQrLoading }] = useBanQrMutation();
    const [fetchBanQrById] = useFetchBanQrByIdMutation();
    const { data: userTypesData } = useGetAppUserTypeQuery({
        tenant_id: JSON.parse(sessionStorage.getItem("vendorData"))?.tenant_id,
    });

    const [showBanModal, setShowBanModal] = useState(false);
    const [selectedQrForBan, setSelectedQrForBan] = useState(null);
    const [tempBannedUsers, setTempBannedUsers] = useState([]);
    const [initialBannedUsers, setInitialBannedUsers] = useState([]);

    const handleBanClick = async (row) => {
        setSelectedQrForBan(row);
        try {
            const res = await fetchBanQrById({
                token: sessionStorage.getItem("access_token"),
                tenant_id: JSON.parse(sessionStorage.getItem("vendorData")).tenant_id,
                qr_id: row.id,
            }).unwrap();

            console.log(res)

            if (res.body && res.body.qrBanList && res.body.qrBanList.length > 0) {
                let blockedType = res.body.qrBanList.map(el => String(el.user_type_id))
                console.log(blockedType)
                setTempBannedUsers(blockedType);
                setInitialBannedUsers(blockedType);
            } else {
                setTempBannedUsers([]);
                setInitialBannedUsers([]);
            }
        } catch (error) {
            console.error("Error fetching ban status:", error);
            setTempBannedUsers([]);
            setInitialBannedUsers([]);
        }
        setShowBanModal(true);
    };

    const handleBanCheckboxChange = (userTypeId) => {
        setTempBannedUsers((prev) =>
            prev.includes(userTypeId)
                ? prev.filter((id) => id !== userTypeId)
                : [...prev, userTypeId]
        );
    };

    const handleBanSubmit = async () => {
        const added = tempBannedUsers.filter(id => !initialBannedUsers.includes(id));
        const removed = initialBannedUsers.filter(id => !tempBannedUsers.includes(id));
        const diff = [...added, ...removed];

        if (diff.length === 0) {
            toast.error("No changes to save");
            return;
        }

        try {
            await banQr({
                token: sessionStorage.getItem("access_token"),
                tenant_id: JSON.parse(sessionStorage.getItem("vendorData")).tenant_id,
                body: {
                    qr_id: selectedQrForBan.id,
                    user_type: diff,
                },
            }).unwrap();
            toast.success("QR Ban status updated successfully");
            setShowBanModal(false);
        } catch (error) {
            toast.error("Failed to update QR ban status");
        }
    };

    const fetchAllQrCodeFunction = () => {
        qrListDataFun({
            token: sessionStorage.getItem("access_token"),
            tenant_id: JSON.parse(sessionStorage.getItem("vendorData"))
                .tenant_id,
            body: request,
        });
    };

    const [
        qrLiCsvDataFun,
        {
            data: qrLiCsvData,
            isLoading: qrLiCsvDataIsLoading,
            error: qrLiCsvDataError,
        },
    ] = useFetchAllQrCodeWithoutGenerationMutation();

    const generateExcel = async (data) => {
        if (!data || !data.body || !data.body.qrsList || data.body.qrsList.length === 0) {
            return;
        }

        const workbook = new ExcelJS.Workbook();
        const worksheet = workbook.addWorksheet("QR Data");

        // Define columns
        worksheet.columns = [
            { header: "Id", key: "id", width: 10 },
            { header: "Batch Running Code", key: "batch_running_code", width: 25 },
            { header: "Unique Code", key: "unique_code", width: 40 },
            { header: "Scratch Code", key: "scratch_code", width: 20 },
            { header: "Product Code", key: "product_code", width: 20 },
            { header: "MRP", key: "mrp", width: 15 },
            { header: "Created At", key: "created_at", width: 25 },
            { header: "Created By", key: "created_by_name", width: 25 },
            { header: "QR Status", key: "qr_status", width: 15 },
        ];

        // Add rows
        data.body.qrsList.forEach((item, index) => {
            worksheet.addRow({
                id: index + 1,
                batch_running_code: item.batch_running_code,
                unique_code: item.unique_code,
                scratch_code: item.scratch_code,
                product_code: item.product_code,
                mrp: item.mrp,
                created_at: item.created_at,
                created_by_name: item.created_by_name,
                qr_status: item.qr_status == "2" ? "Scanned" : "Not Scanned",
            });
        });

        // Formatting
        worksheet.getRow(1).font = { bold: true };
        worksheet.getRow(1).alignment = { vertical: 'middle', horizontal: 'center' };

        // Generate buffer and save
        const buffer = await workbook.xlsx.writeBuffer();
        const blob = new Blob([buffer], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });
        saveAs(blob, `qr_data_${new Date().getTime()}.xlsx`);
    };

    const generateCSV = (data) => {
        if (data.body.qrsList.length === 0) {
            return "";
        }

        const header = [
            "Id",
            "Batch Running Code",
            "Unique Code",
            "Scratch Code",
            "Product Code",
            "MRP",
            "Created At",
            "Created By",
            "QR Status"
        ];
        const rows = data.body.qrsList.map((item, index) => [
            index + 1,
            item.batch_running_code,
            item.unique_code,
            item.scratch_code,
            item.product_code,
            item.mrp,
            item.created_at,
            item.created_by_name,
            item.qr_status == "2" ? "Scanned" : "Not Scanned"
        ]);

        const csvContent = [header, ...rows]
            .map((row) => row.map((cell) => `"${cell}"`).join(","))
            .join("\n");

        return `data:text/csv;charset=utf-8,${encodeURIComponent(csvContent)}`;
    };

    useEffect(() => {
        qrListDataCountFun({
            token: sessionStorage.getItem("access_token"),
            tenant_id: JSON.parse(sessionStorage.getItem("vendorData"))
                .tenant_id,
            body: requestCount,
        });
    }, [requestCount]);

    useEffect(() => {
        if (qrLiCsvData?.body?.qrsList?.length > 0) {
            let qrList2 = [...qrLiCsvData.body.qrsList];
            const chunkSize = 1000000; // 10 lakh entries

            let qrList = qrList2.map((x) => ({
                ...x,
                unique_code: `http://gverify.me/?${x.unique_code}`,
            }));

            const modifiedBody = {
                ...qrLiCsvData.body,
                qrsList: qrList, // qrList is the modified array
            };

            const newData = { body: modifiedBody };

            if (downloadFormat === "xlsx") {
                generateExcel(newData);
            } else {
                if (qrList.length <= chunkSize) {
                    const csvDataUri = generateCSV(newData);
                    downloadCSV(csvDataUri, "qr_data.csv");
                } else {
                    // Divide data into chunks
                    for (let i = 0; i < qrList.length; i += chunkSize) {
                        const chunk = qrList.slice(i, i + chunkSize);
                        const chunkData = { body: { qrsList: chunk } };
                        const csvDataUri = generateCSV(chunkData);
                        downloadCSV(
                            csvDataUri,
                            `qr_data_chunk_${i / chunkSize + 1}.csv`
                        );
                    }
                }
            }
        }
    }, [qrLiCsvData]);

    const downloadCSV = (dataUri, fileName) => {
        const downloadLink = document.createElement("a");
        downloadLink.href = dataUri;
        downloadLink.download = fileName;
        downloadLink.style.display = "none";
        document.body.appendChild(downloadLink);

        downloadLink.click();

        document.body.removeChild(downloadLink);
    };

    useEffect(() => {
        if (qrLiCsvDataError) {
            toast.error("Something went wrong", { id: "qrLiCsvDataError" });
        }
    }, [qrLiCsvDataError]);

    const qrListDownLoad = (format = "csv") => {
        setDownloadFormat(format);
        const modifiedRequest = {
            ...request,
            limit: null,
            offset: null,
        };
        qrLiCsvDataFun({
            token: sessionStorage.getItem("access_token"),
            tenant_id: JSON.parse(sessionStorage.getItem("vendorData"))
                .tenant_id,
            body: modifiedRequest,
        });
    };

    useEffect(() => {
        fetchAllQrCodeFunction();

        let tempRequest = { ...request };
        delete tempRequest.limit;
        delete tempRequest.offset;

        if (!objectsAreEqual(tempRequest, requestCount)) {
            setRequestCount(tempRequest);
        }
    }, [request, limit, offset]);

    const [showQr, setShowQr] = useState(false);
    const [qrData, setQrData] = useState(null);

    useEffect(() => {
        if (qrListData) {
            setMyList(
                qrListData && qrListData.body ? qrListData.body.qrsList : []
            );
        }
    }, [qrListData]);

    useEffect(() => {
        if (qrListDataCount) {
            setTotalRows(
                qrListDataCount && qrListDataCount.body
                    ? qrListDataCount.body.total_qr
                    : 0
            );
        }
    }, [qrListDataCount]);

    const handleShowQr = (data) => {
        let obj = {
            link: data.unique_code.includes("gverify.me")
                ? data.unique_code
                : `http://gverify.me/?${data.unique_code}`,
            ...data,
        };

        setQrData(obj);
        setShowQr(true);
    };

    const handlePageChange = (pageNumber) => {
        const newOffset = (pageNumber - 1) * limit;
        setOffset(newOffset);
        setRequest((prevRequest) => ({ ...prevRequest, offset: newOffset }));
        setCurrentPage(pageNumber);
    };

    const handlePerRowsChange = (newPerPage, page) => {
        setRequest((prevRequest) => ({
          ...prevRequest,
          limit: newPerPage,
          offset: 0,
        }));
        setLimit(newPerPage);
    setOffset(0);
        setCurrentPage(1);
        setPaginationResetToggle((prev) => !prev);

    };

    const handleBatchShowQr = (data) => {
        let obj = {
            link: `${data.unique_code}`,
            ...data,
        };

        // Ultimatrue Specific Changes
        if (JSON.parse(sessionStorage.getItem("vendorData")).tenant_id == 17) {
            obj.link = `${process.env.REACT_APP_QR_URL}genefied/verifyQr?qrCode=${data.unique_code}`;
        }

        setQrData(obj);
        setShowQr(true);
    };

    const handleWebGenefiedQr = (data) => {
        let obj = {
            link: `${process.env.REACT_APP_QR_URL}genefied/verifyQr?qrCode=${data.unique_code}`,
            // link: `${data.unique_code}`,
            ...data,
        };

        setQrData(obj);
        setShowQr(true);
    };
    return (
        <>
            {/* {myList&&myList.length>0 && <CircleLoaderComponent />} */}
            <div className="flex w-full bg-gray-200 h-full justify-center">
                <div className="w-full ">
                    <div className="border-b bg-white border-gray-300 pl-6 py-2 shadow-sm text-xl font-bold">
                        All Qrs List
                        <LinksComponent />
                    </div>
                    <div className="p-3">
                        <div className="flex gap-2">
                            <Menu as="div" className="relative inline-block text-left mb-2">
                                <div>
                                    <Menu.Button className="flex justify-center items-center rounded bg-primary px-3 pb-2 break-normal pt-2 text-xs font-medium uppercase leading-normal text-white shadow-[0_4px_9px_-4px_#3b71ca] transition duration-150 ease-in-out hover:bg-primary-600 hover:shadow-[0_8px_9px_-4px_rgba(59,113,202,0.3),0_4px_18px_0_rgba(59,113,202,0.2)] focus:bg-primary-600 focus:shadow-[0_8px_9px_-4px_rgba(59,113,202,0.3),0_4px_18px_0_rgba(59,113,202,0.2)] focus:outline-none focus:ring-0 active:bg-primary-700 active:shadow-[0_8px_9px_-4px_rgba(59,113,202,0.3),0_4px_18px_0_rgba(59,113,202,0.2)] dark:shadow-[0_4px_9px_-4px_rgba(59,113,202,0.5)] dark:hover:shadow-[0_8px_9px_-4px_rgba(59,113,202,0.2),0_4px_18px_0_rgba(59,113,202,0.1)] dark:focus:shadow-[0_8px_9px_-4px_rgba(59,113,202,0.2),0_4px_18px_0_rgba(59,113,202,0.1)] dark:active:shadow-[0_8px_9px_-4px_rgba(59,113,202,0.2),0_4px_18px_0_rgba(59,113,202,0.1)] gap-x-1.5 ">
                                        Download
                                        <AiOutlineCloudDownload className="-mr-1 h-4 w-4 text-white" aria-hidden="true" />
                                    </Menu.Button>
                                </div>

                                <Transition
                                    as={Fragment}
                                    enter="transition ease-out duration-100"
                                    enterFrom="transform opacity-0 scale-95"
                                    enterTo="transform opacity-100 scale-100"
                                    leave="transition ease-in duration-75"
                                    leaveFrom="transform opacity-100 scale-100"
                                    leaveTo="transform opacity-0 scale-95"
                                >
                                    <Menu.Items className="absolute left-0 z-10 mt-2 w-36 origin-top-left rounded-md bg-white shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none">
                                        <div className="py-1">
                                            <Menu.Item>
                                                {({ active }) => (
                                                    <button
                                                        onClick={() => qrListDownLoad('csv')}
                                                        className={`${active ? 'bg-gray-100 text-gray-900' : 'text-gray-700'
                                                            } block w-full px-4 py-2 text-left text-xs`}
                                                    >
                                                        Download CSV
                                                    </button>
                                                )}
                                            </Menu.Item>
                                            <Menu.Item>
                                                {({ active }) => (
                                                    <button
                                                        onClick={() => qrListDownLoad('xlsx')}
                                                        className={`${active ? 'bg-gray-100 text-gray-900' : 'text-gray-700'
                                                            } block w-full px-4 py-2 text-left text-xs`}
                                                    >
                                                        Download Excel
                                                    </button>
                                                )}
                                            </Menu.Item>
                                        </div>
                                    </Menu.Items>
                                </Transition>
                            </Menu>
                        </div>
                        <div className=" bg-white shadow rounded-lg">
                            <div className="border-b  border-gray-300 bg-gray-50 rounded-t-lg p-3">
                                <div className="flex  space-x-2 justify-between">
                                    <div className="w-52 h-10">
                                        <div className="relative searchin">
                                            <label class="block text-sm font-medium capitalize leading-6 text-gray-900 mb-1">
                                                Batch Running Code
                                            </label>
                                            <input
                                                type="search"
                                                id="default-search"
                                                className="w-full px-2 text-sm text-gray-900 border border-gray-300 rounded-lg bg-white focus:ring-blue-500 focus:border-blue-500 inputp"
                                                placeholder="Batch Running Code..."
                                                required
                                                value={
                                                    request.batch_running_code
                                                }
                                                onChange={(e) => {
                                                    const newValue =
                                                        e.target.value;
                                                    setRequest((prevState) => {
                                                        return {
                                                            ...prevState,
                                                            batch_running_code:
                                                                newValue,
                                                        };
                                                    });
                                                }}
                                            />
                                        </div>
                                    </div>
                                    <div className="w-52 h-10">
                                        <div className="relative searchin">
                                            <label class="block text-sm font-medium capitalize leading-6 text-gray-900 mb-1">
                                                QR/Barcode code
                                            </label>
                                            <input
                                                type="search"
                                                id="default-search"
                                                className="w-full px-2 text-sm text-gray-900 border border-gray-300 rounded-lg bg-white focus:ring-blue-500 focus:border-blue-500 inputp"
                                                placeholder="QR/Barcode"
                                                required
                                                value={
                                                    request.qr_barcode
                                                }
                                                onChange={(e) => {
                                                    const newValue =
                                                        e.target.value;
                                                    setRequest((prevState) => {
                                                        return {
                                                            ...prevState,
                                                            qr_barcode:
                                                                newValue,
                                                        };
                                                    });
                                                }}
                                            />
                                        </div>
                                    </div>
                                    <div className="w-52 h-10">
                                        <div className="relative searchin">
                                            <label class="block text-sm font-medium capitalize leading-6 text-gray-900 mb-1">
                                                Scratch Code
                                            </label>
                                            <input
                                                type="search"
                                                id="scratch-code-search"
                                                className="w-full px-2 text-sm text-gray-900 border border-gray-300 rounded-lg bg-white focus:ring-blue-500 focus:border-blue-500 inputp"
                                                placeholder="Scratch Code..."
                                                value={request.scratch_code}
                                                onChange={(e) => {
                                                    const newValue = e.target.value;
                                                    setRequest((prevState) => ({
                                                        ...prevState,
                                                        scratch_code: newValue,
                                                    }));
                                                }}
                                            />
                                        </div>
                                    </div>
                                    <div className="w-52 h-10">
                                        <div className="relative searchin">
                                            <label class="block text-sm font-medium capitalize leading-6 text-gray-900 mb-1">
                                                Product Name
                                            </label>
                                            <input
                                                type="search"
                                                id="default-search"
                                                className="w-full px-2 text-sm text-gray-900 border border-gray-300 rounded-lg bg-white focus:ring-blue-500 focus:border-blue-500 inputp"
                                                placeholder="Product Name..."
                                                required
                                                value={request.product_name}
                                                onChange={(e) => {
                                                    const newValue =
                                                        e.target.value;
                                                    setRequest((prevState) => {
                                                        return {
                                                            ...prevState,
                                                            product_name:
                                                                newValue,
                                                        };
                                                    });
                                                }}
                                            />
                                        </div>
                                    </div>
                                    <div className="relative searchin">
                                        <label class="block text-sm font-medium capitalize leading-6 text-gray-900 mb-1">
                                            Product Code
                                        </label>
                                        <input
                                            type="search"
                                            id="default-search"
                                            className="w-full px-2 text-sm text-gray-900 border border-gray-300 rounded-lg bg-white focus:ring-blue-500 focus:border-blue-500 inputp"
                                            placeholder="Product Code ..."
                                            required
                                            value={request.product_code}
                                            onChange={(e) => {
                                                const newValue = e.target.value;
                                                setRequest((prevState) => {
                                                    return {
                                                        ...prevState,
                                                        product_code: newValue,
                                                    };
                                                });
                                            }}
                                        />
                                    </div>
                                    <div className="relative searchin">
                                        <label class="block text-sm font-medium capitalize leading-6 text-gray-900 mb-1">
                                            Start Date
                                        </label>
                                        <input
                                            type="date"
                                            id="default-search"
                                            className="w-full px-2 text-sm text-gray-900 border border-gray-300 rounded-lg bg-white focus:ring-blue-500 focus:border-blue-500 inputp"
                                            placeholder="Start Date"
                                            value={request.startDate}
                                            onChange={(e) => {
                                                const newValue = e.target.value;
                                                setRequest((prevState) => {
                                                    return {
                                                        ...prevState,
                                                        startDate: newValue,
                                                    };
                                                });
                                            }}
                                        />
                                    </div>
                                    <div className="relative searchin">
                                        <label class="block text-sm font-medium capitalize leading-6 text-gray-900 mb-1">
                                            End Date
                                        </label>
                                        <input
                                            type="date"
                                            id="default-search"
                                            className="w-full px-2 text-sm text-gray-900 border border-gray-300 rounded-lg bg-white focus:ring-blue-500 focus:border-blue-500 inputp"
                                            placeholder="End Date"
                                            value={request.endDate}
                                            onChange={(e) => {
                                                const newValue = e.target.value;
                                                setRequest((prevState) => {
                                                    return {
                                                        ...prevState,
                                                        endDate: newValue,
                                                    };
                                                });
                                            }}
                                        />
                                    </div>
                                    {isLancerFootwear && (
                                        <div className="flex gap-4 items-end">
                                            <div className="w-64">
                                                <label className="block text-sm font-medium leading-6 text-gray-900 mb-1">
                                                    Select Address
                                                </label>
                                                <select
                                                    className="w-full px-2 py-1.5 text-sm text-gray-900 border border-gray-300 rounded-lg bg-white focus:ring-blue-500 focus:border-blue-500"
                                                    value={request.address_id}
                                                    onChange={(e) => {
                                                        const newValue = e.target.value;
                                                        setRequest((prevState) => ({
                                                            ...prevState,
                                                            address_id: newValue,
                                                        }));
                                                    }}
                                                >
                                                    <option value="">All Addresses</option>
                                                    {addresses.map((address) => (
                                                        <option key={address.id} value={address.id}>
                                                            {address.place_name}
                                                        </option>
                                                    ))}
                                                </select>
                                            </div>
                                        </div>
                                    )}
                                    <div className="flex flex-row gap-2  w-56 h-10">
                                        <div className="relative searchin">
                                            <label class="block text-sm font-medium capitalize leading-6 text-gray-900 mb-1">
                                                &nbsp;
                                            </label>
                                            <button
                                                className="btn btn-outline-primary clear-both float-right pdbtn_all "
                                                onClick={() => {
                                                    fetchAllQrCodeFunction();
                                                }}
                                            >
                                                Search
                                            </button>
                                        </div>
                                        <div className="relative searchin">
                                            <label class="block text-sm font-medium capitalize leading-6 text-gray-900 mb-1">
                                                &nbsp;
                                            </label>
                                            <button
                                                className="btn btn-outline-primary clear-both float-right pdbtn_all whitespace-nowrap"
                                                onClick={() => {
                                                    clearFilters();
                                                }}
                                            >
                                                Clear Filters
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <DataTableComponent
                                keyField={(row) => row.SNo}
                                columns={columns}
                                // title={"Product List"}
                                data={myList}
                                loading={loading}
                                totalRows={totalRows}
                                handlePerRowsChange={handlePerRowsChange}
                                handlePageChange={handlePageChange}
                                paginationDefaultPage={currentPage}
                                paginationResetDefaultPage={paginationResetToggle}
                            ></DataTableComponent>
                        </div>
                    </div>
                </div>
                {showQr && (
                    <ViewQr data={qrData} show={showQr} setShow={setShowQr} />
                )}

                {showBanModal && (
                    <ModalComponent
                        show={showBanModal}
                        setShow={setShowBanModal}
                        size="xl"
                    >
                        <div className="p-4">
                            <h2 className="text-xl font-bold border-b pb-2 mb-4">
                                Ban QR: {selectedQrForBan?.unique_code}
                            </h2>
                            <h3 className="text-lg font-semibold mb-4">Select User Types to Ban</h3>
                            <div className="grid grid-cols-2 gap-4">
                                {userTypesData?.body?.map((type) => (
                                    <div key={type.user_type_id} className="flex items-center gap-2">
                                        <input
                                            type="checkbox"
                                            id={`user-type-${type.user_type_id}`}
                                            checked={tempBannedUsers.includes(String(type.user_type_id))}
                                            onChange={() => handleBanCheckboxChange(String(type.user_type_id))}
                                            className="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500"
                                        />
                                        <label
                                            htmlFor={`user-type-${type.user_type_id}`}
                                            className="text-sm font-medium text-gray-900 capitalize"
                                        >
                                            {type.user_type}
                                        </label>
                                    </div>
                                ))}
                            </div>
                            <div className="mt-6 flex justify-end gap-3">
                                <button
                                    onClick={() => setShowBanModal(false)}
                                    className="px-4 py-2 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-md hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
                                >
                                    Cancel
                                </button>
                                <button
                                    onClick={handleBanSubmit}
                                    disabled={banQrLoading}
                                    className="px-4 py-2 text-sm font-medium text-white bg-red-600 border border-transparent rounded-md hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-500 disabled:opacity-50"
                                >
                                    {banQrLoading ? "Saving..." : "Save Changes"}
                                </button>
                            </div>
                        </div>
                    </ModalComponent>
                )}
            </div>
        </>
    );
};

export default AllQrCodeList;
